"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useState } from "react";
import { ArrowRight, Circle } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const seasons = [{
  value: "nasional",
  label: "Nasional"
}, {
  value: "daerah",
  label: "Daerah"
}, {
  value: "opini",
  label: "Opini"
}, {
  value: "klarifikasi",
  label: "Klarifikasi"
}];
const sessions = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_nasional_utama.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_nasional_utama.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_nasional_utama.png-wvc-sizes",
  alt: "Liputan berita nasional terkini",
  day: "24",
  month: "Mei",
  year: "2024",
  format: "LAPORAN UTAMA",
  titleStart: "Dinamika Politik ",
  titleItalic: "Pasca Pemilu",
  titleEnd: "",
  description: "Analisis mendalam mengenai pergeseran koalisi dan arah kebijakan pemerintah baru dalam menghadapi tantangan ekonomi global.",
  instructor: "Redaksi Pusat",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/redaksi_avatar_1.webp",
  avatarFallback: "RP",
  seatsLeft: 4,
  seatsTotal: 12,
  investment: "Gratis",
  soldOut: false,
  limited: true,
  season: "nasional",
  offset: false
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_daerah_terkini.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_daerah_terkini.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_daerah_terkini.png-wvc-sizes",
  alt: "Pembangunan infrastruktur di daerah",
  day: "22",
  month: "Mei",
  year: "2024",
  format: "KABAR DAERAH",
  titleStart: "Inovasi Desa Digital di ",
  titleItalic: "Jawa Barat",
  titleEnd: "",
  description: "Bagaimana teknologi merubah wajah pedesaan dan meningkatkan taraf hidup petani melalui akses pasar digital yang lebih luas.",
  instructor: "Budi Santoso",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kontributor_budi.png",
  avatarFallback: "BS",
  seatsLeft: 8,
  seatsTotal: 12,
  investment: "Gratis",
  soldOut: false,
  limited: false,
  season: "daerah",
  offset: true
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opini_pakar_ekonomi.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opini_pakar_ekonomi.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opini_pakar_ekonomi.png-wvc-sizes",
  alt: "Diskusi panel ekonomi",
  day: "20",
  month: "Mei",
  year: "2024",
  format: "KOLOM OPINI",
  titleStart: "Masa Depan ",
  titleItalic: "Ekonomi Hijau",
  titleEnd: " di Indonesia",
  description: "Perspektif kritis mengenai transisi energi dan kesiapan industri manufaktur dalam mengadopsi standar keberlanjutan internasional.",
  instructor: "Dr. Ahmad",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pakar_ahmad.png",
  avatarFallback: "DA",
  seatsLeft: 0,
  seatsTotal: 12,
  investment: "Premium",
  soldOut: true,
  limited: false,
  season: "opini",
  offset: false
}, {
  id: 4,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_berita_hoax.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_berita_hoax.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_berita_hoax.png-wvc-sizes",
  alt: "Pemeriksaan fakta berita",
  day: "19",
  month: "Mei",
  year: "2024",
  format: "CEK FAKTA",
  titleStart: "Klarifikasi Isu Kenaikan ",
  titleItalic: "Harga BBM",
  titleEnd: "",
  description: "Menelusuri kebenaran informasi yang beredar di media sosial mengenai rencana penyesuaian harga bahan bakar minyak bersubsidi.",
  instructor: "Tim Cek Fakta",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/cek_fakta_logo.png",
  avatarFallback: "CF",
  seatsLeft: 3,
  seatsTotal: 10,
  investment: "Publik",
  soldOut: false,
  limited: true,
  season: "klarifikasi",
  offset: true
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pancasila_youth_event.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pancasila_youth_event.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pancasila_youth_event.png-wvc-sizes",
  alt: "Kegiatan Pemuda Pancasila",
  day: "15",
  month: "Mei",
  year: "2024",
  format: "ZONA PP",
  titleStart: "Aksi Sosial ",
  titleItalic: "Bakti Negeri",
  titleEnd: "",
  description: "Laporan eksklusif kegiatan kemanusiaan dan pemberdayaan pemuda di berbagai wilayah untuk memperkuat persatuan bangsa.",
  instructor: "Sekretariat PP",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pp_logo_avatar.png",
  avatarFallback: "PP",
  seatsLeft: 6,
  seatsTotal: 12,
  investment: "Internal",
  soldOut: false,
  limited: false,
  season: "nasional",
  offset: false
}, {
  id: 6,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_corner_news.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_corner_news.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_corner_news.png-wvc-sizes",
  alt: "Driver ojek online berkumpul",
  day: "12",
  month: "Mei",
  year: "2024",
  format: "POJOK OJOL",
  titleStart: "Suara dari ",
  titleItalic: "Aspal",
  titleEnd: " — Aspirasi Driver",
  description: "Ruang khusus bagi para pejuang transportasi daring untuk menyampaikan keluh kesah dan harapan terhadap regulasi terbaru.",
  instructor: "Admin Ojol",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/ojol_avatar.png",
  avatarFallback: "AO",
  seatsLeft: 2,
  seatsTotal: 12,
  investment: "Komunitas",
  soldOut: false,
  limited: true,
  season: "daerah",
  offset: true
}];
export default function UnitsGrid() {
  const [activeSeason, setActiveSeason] = useState<string>("");
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const filtered = activeSeason ? sessions.filter(s => s.season === activeSeason) : sessions;
  return <section data-section-id="3046" id="units-grid" className="bg-background text-foreground py-24 md:py-32 lg:py-44">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div ref={header.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-end transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-6 lg:col-start-2">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-6">
              Arsip Berita — Edisi 2024
            </p>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-foreground">
              Informasi akurat untuk{" "}
              <span className="italic">masyarakat cerdas.</span>
            </h2>
          </div>

          <div className="lg:col-span-3 lg:col-start-9 flex lg:justify-end">
            <ToggleGroup type="single" value={activeSeason} onValueChange={v => setActiveSeason(v)} variant="outline" className="flex-wrap gap-2 rounded-md border-0">
              {seasons.map((s, i) => <ToggleGroupItem key={s.value} data-index={i} value={s.value} className="font-mono text-[10px] tracking-[0.2em] uppercase px-4 py-2 rounded-md border border-border first:rounded-md last:rounded-md data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:border-primary text-foreground hover:bg-accent">
                  {s.label}
                </ToggleGroupItem>)}
            </ToggleGroup>
          </div>
        </div>

        <div className="mt-20 lg:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {filtered.map((session, i) => {
          const card = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15,
            rootMargin: "0px 0px -50px 0px"
          });
          return <div key={session.id} data-index={i} ref={card.ref} className={`transition-all duration-[900ms] ease-out ${card.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"} ${session.offset ? "lg:mt-6" : ""}`} style={{
            transitionDelay: `${i % 3 * 120}ms`
          }}>
                <Card className={`group h-full border border-border bg-card rounded-lg p-0 gap-0 transition-all duration-[800ms] ease-out hover:-translate-y-2 hover:shadow-lg ${session.soldOut ? "opacity-90" : ""}`}>
                  <CardContent className="p-8 lg:p-10 flex flex-col h-full">
                    <div className="relative overflow-hidden rounded-md aspect-[4/3] mb-8">
                      <img src={session.image} data-wvc-srcset={session.srcset} data-wvc-sizes={session.sizes} alt={session.alt} loading="lazy" decoding="async" className={`w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${session.soldOut ? "grayscale" : ""}`} />
                      {session.soldOut && <div className="absolute inset-0 flex items-start justify-end p-4">
                          <Badge className="bg-background/95 text-foreground border border-border font-default italic text-sm px-3 py-1 rounded-md">
                            Arsip
                          </Badge>
                        </div>}
                    </div>

                    <div className="flex items-baseline gap-3 mb-5">
                      <span className="font-default text-2xl text-foreground">
                        {session.day} {session.month}
                      </span>
                      <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                        {session.year}
                      </span>
                    </div>

                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-primary mb-4">
                      {session.format}
                    </p>

                    <h3 className="font-default text-2xl lg:text-[28px] leading-[1.2] text-foreground mb-4">
                      {session.titleStart}
                      <span className="italic">{session.titleItalic}</span>
                      {session.titleEnd}
                    </h3>

                    <p className="font-default text-base text-muted-foreground leading-relaxed mb-7 line-clamp-3">
                      {session.description}
                    </p>

                    <div className="flex items-center gap-3 mb-7">
                      <SafeHydrate><Avatar className="size-8 rounded-md">
                        <AvatarImage src={session.avatar} alt={session.instructor} />
                        <AvatarFallback className="bg-muted text-foreground text-xs font-mono">
                          {session.avatarFallback}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <p className="font-default italic text-sm text-foreground">
                        Oleh {session.instructor}
                      </p>
                    </div>

                    <div className="mt-auto">
                      <Separator className="mb-5 bg-border" />
                      <div className="grid grid-cols-2 gap-4 mb-6">
                        <div>
                          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground mb-1.5">
                            Status
                          </p>
                          <p className="font-default text-sm text-foreground flex items-center gap-2">
                            {session.limited && !session.soldOut && <Circle className="size-2 fill-primary text-primary" />}
                            {session.soldOut ? "Terverifikasi" : "Berita Terbaru"}
                          </p>
                        </div>
                        <div>
                          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground mb-1.5">
                            Akses
                          </p>
                          <p className="font-default text-sm text-foreground">
                            {session.investment}
                          </p>
                        </div>
                      </div>

                      <Button asChild className="w-full rounded-md bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-[11px] tracking-[0.2em] uppercase h-12">
                        <Link to="/NewsPage">
                          {session.soldOut ? "Baca Selengkapnya" : "Lihat Detail"}
                          <ArrowRight className="size-4" />
                        </Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-24 flex items-center justify-center gap-6">
          <Separator className="flex-1 bg-border" />
          <span className="font-default italic text-xl text-muted-foreground">
            &mdash;
          </span>
          <Separator className="flex-1 bg-border" />
        </div>
      </div>
    </section>;
}